import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateWebinar = props => {
  const { courseId, curriculumId } = props.params
  let seriesId
  let type = 'guest'
  let label = 'Guest'
  let successPartialPath = ''
  if (courseId) {
    seriesId = courseId
    type = 'course'
    label = 'Course'
    successPartialPath = `/courses/${seriesId}`
  } else if (curriculumId) {
    seriesId = curriculumId
    type = 'curriculum'
    label = 'Curriculum'
    successPartialPath = `/curriculums/${seriesId}`
  }

  return (
    <Create
// @ts-ignore
      title={`Create ${label} Webinar`}
      fields={fields}
      apiPath='admin/webinars'
      successRedirectPath={resource => `/events${successPartialPath}/webinars/${resource.id}/edit`}
      buildMenuItems={menuItems}
      resource={{
        series_id: seriesId,
        type: type,
        requires_membership: true
      }}
    />
  )
}

export default CreateWebinar
